import { isProduction } from '../../../utils/urls';
export { isProduction, getIdentityBaseUrl, getWacIntegrationUrl } from '../../../utils/urls';

const IDENTITY_RECAPTCHA_KEY = '6Le9VxMnAAAAALKRlj8jmKwUYmFTZWcF0y4o9QeD';
const IDENTITY_RECAPTCHA_KEY_TEST = '6LcIg3QnAAAAAPmTkAv_ZanJY5dRDUJo-i5hr_aN';

export const getReCaptchaKey = () => {
	return isProduction() ? IDENTITY_RECAPTCHA_KEY : IDENTITY_RECAPTCHA_KEY_TEST;
};
